exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".navbar {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  height: 48px;\n  border-bottom: 1px solid #d8d8d8; }\n  .navbar .\\--icons {\n    font-size: 20px; }\n  .navbar-button {\n    width: 56px;\n    text-align: center;\n    outline: none !important;\n    padding: 0; }\n    .navbar-button__blue {\n      color: #004272; }\n  .navbar .avatar {\n    padding: 0;\n    width: 32px;\n    height: 32px;\n    border-radius: 32px;\n    overflow: hidden;\n    margin-right: 16px; }\n  .navbar .header-back {\n    margin-left: 8px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Navbar/styles.scss
// module id = 1240
// module chunks = 0